import { render, staticRenderFns } from "./jifentiao.vue?vue&type=template&id=51087950&"
import script from "./jifentiao.vue?vue&type=script&lang=ts&"
export * from "./jifentiao.vue?vue&type=script&lang=ts&"
import style0 from "./jifentiao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports